import React from 'react'
export default function SMSContacts() {
  return (
    <div>
      <h1>SMS Contacts</h1>
    </div>
  )
}
